module.exports = __webpack_public_path__ + "img/icon1.ea820358.png";